import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: []
}

export const chemicalSlice = createSlice({
  name: 'chemicalSliceName',
  initialState,
  reducers: {
    addChemical: () => {
    },
    getChemical: () => {
    },
    updateChemical: () => {
    },
    successChemical: (state, action) => {
      state.data = action.payload
    },
    failedChemical: () => {
    }
  },
})

export const { addChemical, getChemical, updateChemical, successChemical, failedChemical } = chemicalSlice.actions

export default chemicalSlice.reducer
